import api from "./api";

export function checkIsInventoryLabel(data) {
  return api.post('/tars/inventory/fetchlabeldetail', JSON.stringify(data))
}